import React from "react";

const MainLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="prefix__logo"
      width="251.764"
      height="62.877"
      viewBox="0 0 251.764 62.877"
    >
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1="-.716"
          x2="-.081"
          y1=".392"
          y2="1.442"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#eb015b" />
          <stop offset="1" stop-color="#ff3d00" />
        </linearGradient>

        <style>
          {
            "\
        .prefix__cls-100{\
            fill:url(#prefix__linear-gradient);\
        }\
      "
          }
        </style>
      </defs>
      <path
        id="prefix__Path_1"
        d="M156.675 6.458a8.461 8.461 0 0 1 8.894-5.986q39.925.016 79.861.011c4.505-.383 8.862 3.366 8.734 7.967q.112 23.485.011 46.971a7.81 7.81 0 0 1-7.679 7.86c-27.341.064-54.682.021-82.033.021a7.841 7.841 0 0 1-7.988-7.882c-.075-4.463.011-8.936-.011-13.409 1.97-.011 3.951-.011 5.933-.043l2.3 1.917c.863-1.065 1.768-2.1 2.684-3.121-1.2-1-2.4-2.024-3.589-3.036q-3.659.016-7.338.021l.011-2.141c3.749 0 7.488.032 11.237-.032q5.927 5.767 11.684 11.705c6 .1 11.993.053 18 .021-4.335-4.633-8.776-9.149-13.122-13.761-1.054-1.012-1.992-2.556-3.685-2.183-8.031-.021-16.072.011-24.1 0l-.032-2.13c8.936.075 17.883-.16 26.808.107 3.451 2.918 6.518 6.273 9.714 9.469.852-.991 1.694-1.992 2.471-3.046-2.365-2.162-4.708-4.346-7.083-6.5a60.377 60.377 0 0 1 7.477.1c3.888 3.472 7.4 7.338 11.12 10.992.884-.905 1.768-1.821 2.652-2.727-4.133-3.824-8.105-7.818-12.27-11.609-13.622.043-27.245 0-40.868.021v-3.2c9.905.011 19.821-.032 29.737.021v-3.244c-9.916.064-19.821 0-29.737.032.1-4.388-.256-8.808.213-13.186m79.4 36.309c-4.026 1.63-4.505 7.818-.937 10.193a5.962 5.962 0 0 0 9.181-2.844c2.063-4.729-3.795-9.905-8.247-7.349z"
        class="prefix__cls-100"
        data-name="Path 1"
        transform="translate(-2.449 -.439)"
      />
      <path
        id="prefix__Path_2"
        d="M117.99 7.666q2.349-2.333 4.676-4.676 2.253 2.269 4.516 4.537l-4.654 4.654c-1.513-1.501-3.028-3.013-4.538-4.515z"
        class="prefix__cls-100"
        data-name="Path 2"
        transform="translate(-2.773 -.273)"
      />
      <path
        id="prefix__Path_3"
        d="M28.484 7.937c2.194-.533 4.4-1.054 6.593-1.587.522 10.512.788 21.025 1.161 31.527.043 3.9-.607 8.127-3.376 11.077-5.656 6.5-17.223 6.316-22.569-.479-2.568-3.26-2.493-7.584-2.163-11.504 1.875-.075 3.738-.117 5.613-.138-.362 2.886-.343 6.252 2.237 8.167 4.782 4.857 14.794 1.225 14.624-5.847-.395-10.425-1.13-20.831-2.12-31.216z"
        class="prefix__cls-100"
        data-name="Path 3"
        transform="translate(-7.965 -.054)"
      />
      <path
        id="prefix__Path_4"
        d="M38.09 8.175q3.083-.943 6.178-1.875a114.82 114.82 0 0 1 .618 22.058c0 1.885-.192 5.5 2.578 5.294 14.954.053 29.9.011 44.851.021q0 3.243.011 6.5c-14.6.351-29.215.107-43.828.128-4.569.266-9.618-2.727-9.65-7.733.062-8.13.318-16.309-.758-24.393z"
        class="prefix__cls-100"
        data-name="Path 4"
        transform="translate(-6.004 -.058)"
      />
      <path
        id="prefix__Path_5"
        d="M89.96 8.022C92.175 8 94.391 8 96.606 7.99a173.1 173.1 0 0 1 .8 31.165q-3.2.543-6.4 1.033A151.137 151.137 0 0 0 89.96 8.022z"
        class="prefix__cls-100"
        data-name="Path 5"
        transform="translate(-4.088 .052)"
      />
      <path
        id="prefix__Path_6"
        d="M117.206 27.745c-2.109-5.57 1.8-14.538 8.617-13.591 7.7 2.162 10.246 12.494 7.488 19.236-4.037 6.731-13.292 6.6-20.173 6.039-1.843 7.317-7.85 12.611-14.379 15.849-1-2.141-.756-4.537-.778-6.827 3.738-2.45 7.967-5.187 9.32-9.7.437-4.1-1.576-7.85-3.121-11.5 1.97-.841 3.93-1.693 5.879-2.578 1.406 2.876 1.864 6.934 5.08 8.425A38.543 38.543 0 0 0 129 31.558c-4.047-.043-9.756.671-11.791-3.813m4.7-2.279a30.778 30.778 0 0 0 6.625.788c-.692-1.928-1.108-4.271-2.95-5.475-2.744-.937-4.001 2.503-3.684 4.687z"
        class="prefix__cls-100"
        data-name="Path 6"
        transform="translate(-3.918 .449)"
      />
      <path
        id="prefix__Path_7"
        d="M171.95 33.473c2.588.053 5.23-.245 7.786.181 2.78 2.247 5.262 4.846 7.914 7.253-2.556.032-5.1.021-7.658.032-2.685-2.481-5.337-5.005-8.042-7.466z"
        class="prefix__cls-100"
        data-name="Path 7"
        transform="translate(-.307 1.708)"
      />
      <path
        id="prefix__Path_8"
        d="M72.63 44.484c1.331-1.331 2.652-2.663 3.983-3.994q1.933 1.949 3.866 3.877 1.933-1.933 3.866-3.877c1.331 1.331 2.652 2.663 3.983 4-1.331 1.331-2.673 2.663-4 3.994q-1.917-1.933-3.845-3.845-1.933 1.917-3.866 3.856c-1.324-1.338-2.656-2.669-3.987-4.011z"
        class="prefix__cls-100"
        data-name="Path 8"
        transform="translate(-4.945 2.168)"
      />
      <path
        id="prefix__Path_9"
        d="M76.5 50.086c1.246-1.236 2.482-2.471 3.728-3.7q1.805 1.789 3.589 3.579-1.853 1.869-3.728 3.738C78.9 52.5 77.693 51.3 76.5 50.086z"
        class="prefix__cls-100"
        data-name="Path 9"
        transform="translate(-4.722 2.552)"
      />
    </svg>
  );
};

export default MainLogo;
